import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendNewsForm from './FrontendNewsForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendNews extends Component {
    render() {
        const columns = [
            { label: 'หัวข้อข่าว', align: 'left', name: 'topic', search_type: 'string' },
            { label: 'รูปแบบข่าว', align: 'center', name: 'news_type', sortable: false },
            { label: 'แสดงหน้าหลัก', align: 'center', name: 'feature', sortable: false },
        ];

        const api_url = '/master/news';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='ข่าวสาร' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendNewsForm {...props} url={api_url}></FrontendNewsForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendNewsForm {...props} url={api_url}></FrontendNewsForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendNews
